<template>
  <div class="common-nav">
    <nav>
      <ul class="common-nav.menus">
        <li
          v-for="(item, index) in menuLists"
          :key="item.id || item.label || item.url || index"
        >
          <router-link
            :to="item.url"
            :class="{ '+activeTab': isMenuActive(item) }"
          >
            <i :class="'fa' + ' ' + item.icon"></i>
            <strong>{{ item.name }}</strong>
          </router-link>
          <ul class="subs" v-if="item.children.length">
            <li v-for="(sub, subIndex) in item.children" :key="sub.id || sub.label || sub.url || subIndex">
              <router-link
                :to="sub.url"
                :class="{ '+activeSub': sub.url == $route.path }"
                ><i :class="'fa' + ' ' + sub.icon"></i
                >{{ sub.name }}</router-link
              >
              <ul v-if="sub.children.length">
                <li v-for="(sSub, sSubIndex) in sub.children" :key="sSub.id || sSub.label || sSub.url || sSubIndex">
                  <router-link
                    :to="sSub.url"
                    :class="{ '+activeSub': sSub.url == $route.path }"
                    ><i :class="'fa' + ' ' + sub.icon"></i
                    >{{ sSub.name }}</router-link
                  >
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
const OBSOLETE_MENU_URLS = ["/transfer/enterpriseInnovationPoint"];

export default {
  data() {
    return {
      home: [
        // {
        // 	name: '首页',
        // 	url: '/home',
        // 	label: 'home',
        // 	icon: 'fa-home'
        // }
      ],
      menuLists: [],
      menuRequestId: 0,
    };
  },
  computed: {
    roleId() {
      const userInfo = this.$store.getters.userInfo;
      if (!userInfo) return 0;
      try {
        const parsed = typeof userInfo === "string" ? JSON.parse(userInfo) : userInfo;
        return Number(parsed.roleId) || 0;
      } catch (error) {
        return 0;
      }
    },
  },
  methods: {
    normalizeMenuTree(items) {
      if (!Array.isArray(items)) return [];
      return items.reduce((menus, item) => {
        if (!item || typeof item !== "object") return menus;
        const children = this.normalizeMenuTree(item.children);
        const ownUrl = typeof item.url === "string" ? item.url.trim() : "";
        if (OBSOLETE_MENU_URLS.indexOf(ownUrl) !== -1) return menus;
        const url = children.length ? children[0].url : ownUrl;
        if (!url) return menus;
        menus.push(Object.assign({}, item, { url, children }));
        return menus;
      }, []);
    },
    isMenuActive(item) {
      if (!item) return false;
      if (item.url === this.$route.path) return true;
      return item.children.some((child) => this.isMenuActive(child));
    },
    getMenuList() {
      const requestId = ++this.menuRequestId;
      if (!this.roleId) {
        this.menuLists = this.home;
        return;
      }
      this.http
        .get(`${this.urlConfig.devUrl}apij2/admin-api/system/admin-role/get?id=${this.roleId}`)
        .then((res) => {
          if (requestId !== this.menuRequestId) return;
          const data = res && res.data ? res.data : {};
          const menuIds = data.menuIds || data.menu_ids || [];
          this.menuLists = this.home.concat(this.normalizeMenuTree(menuIds));
        })
        .catch(() => {
          if (requestId === this.menuRequestId) this.menuLists = this.home;
        });
    },
  },
  watch: {
    roleId: {
      handler() {
        this.getMenuList();
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
$activeNavColor: #9853af;

@include component(common-nav) {
  position: relative;
  margin: 0px auto;
  clear: both;
  height: 100%;

  > nav {
    height: 100%;
  }

  @include part(menus) {
    list-style: none;
    padding: 0;
    margin: 0;
    border-radius: 2px;
    width: 100%;
    height: 100%;

    li {
      position: relative;

      a {
        display: block;
        text-decoration: none;
        padding: 20px;
        color: #fff;
        text-align: left;
        height: 56px;
        position: relative;

        //border-bottom: 1px solid red;
        i {
          margin-bottom: 10px;
          float: left;
          font-size: 16px;
          margin: 0 10px 0 0;
          position: relative;
        }

        strong {
          display: block;
          position: relative;
        }
      }

      ul {
        position: absolute;
        // height: auto;
        min-width: 180px;
        max-height: 500px;
        overflow-y: scroll;
        padding: 0;
        margin: 0;
        background: #f2f2f2;
        opacity: 0;
        visibility: hidden;
        transition: all 300ms linear;
        z-index: 1000;
        left: 280px;
        top: 0px;
        border-left: 4px solid $activeNavColor;

        &.subs {
          &:before {
            content: "";
            position: absolute;
            top: 25px;
            left: -9px;
            border-right: 5px solid $activeNavColor;
            border-bottom: 5px solid transparent;
            border-top: 5px solid transparent;
          }
        }

        li {
          a {
            padding: 10px;
            text-align: left;
            border: 0;
            border-bottom: 1px solid #eee;
            height: auto;
            color: #343a40;

            i {
              font-size: 16px;
              display: inline-block;
              margin: 0 10px 0 0;
            }
          }

          ul {
            left: 230px;
            top: 0;
            border: 0;
            border-left: 4px solid $activeNavColor;

            &:before {
              content: "";
              position: absolute;
              top: 15px;
              left: -9px;
              border-right: 5px solid $activeNavColor;
              border-bottom: 5px solid transparent;
              border-top: 5px solid transparent;
            }
          }

          &:hover {
            > ul {
              display: block;
              opacity: 1;
              visibility: visible;
              top: 0px;
              left: 180px;
            }
          }
        }
      }

      &:hover {
        > a {
          color: $activeNavColor;
        }

        > ul {
          display: block;
          opacity: 1;
          visibility: visible;
          left: 180px;
        }
      }
    }
  }

  @include tweak(activeTab) {
    position: relative;
    color: $activeNavColor;
    border: 0;
    //box-shadow: 0 0 5px #DDD;
    // border-left: 4px solid $activeNavColor;
    // border-right: 4px solid $activeNavColor;
    background: linear-gradient(to left, #9853af, #623aa2);
    color: #fff;
    // &:before {
    // 	content: "";
    // 	position: absolute;
    // 	top: 42%;
    // 	left: 0;
    // 	border-left: 5px solid $activeNavColor;
    // 	border-top: 5px solid transparent;
    // 	border-bottom: 5px solid transparent;
    // }

    // &:after {
    // 	content: "";
    // 	position: absolute;
    // 	top: 42%;
    // 	right: 0;
    // 	border-right: 5px solid $activeNavColor;
    // 	border-top: 5px solid transparent;
    // 	border-bottom: 5px solid transparent;
    // }
  }

  @include tweak(activeSub) {
    background: linear-gradient(to left, #9853af, #623aa2);
    color: #fff;
  }
}
</style>
